export default __webpack_public_path__ + "static/media/Walker's Fauld of the Ancestors.df59b7c0.jpg";